<div class="modal-header">
  @if (!productImageOnly && !sampleOnly && !isContentPackagesManager) {
    <h1 id="modal-title" class="modal-title">
      {{ data.id ? ("general.edit" | translate) : ("general.add" | translate) }} {{ "general.product" | translate }}
      {{ data.type == "firmware" ? ("general.firmware" | translate) : ("general.content" | translate) }}
    </h1>
  }
  @if (!productImageOnly && !sampleOnly && isContentPackagesManager) {
    <h1 id="modal-title" class="modal-title">
      {{ data.id ? ("general.edit" | translate) : ("general.add" | translate) }} {{ "general.product" | translate }}
      {{ selectedContentType == "firmware" ? ("general.firmware" | translate) : ("general.content" | translate) }}
    </h1>
  }
  @if (productImageOnly) {
    <h1 id="modal-title" class="modal-title">{{ "content_packages.upload_product_image" | translate }}</h1>
  }
  @if (sampleOnly) {
    <h1 id="modal-title" class="modal-title">{{ data.id ? "Edit Sample" : "Upload Sample" }}</h1>
  }
  <button class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="addEditProductContentLoader"></myp-inline-loader>
  @if (uploadProgress && !uploadingComplete) {
    <div class="text-center">
      <span>{{ "general.uploading" | translate }} {{ uploadingFile.file.name }}</span>
      <br />
      <br />
      <div style="display: inline-block; margin: auto">
        <round-progress
          [current]="uploadProgress"
          [max]="100"
          [color]="'#45ccce'"
          [background]="'#eaeaea'"
          [radius]="125"
          [stroke]="20"
          [semicircle]="false"
          [rounded]="true"
          [clockwise]="true"
          [responsive]="false"
          [duration]="250"
          [animation]="'easeInOutQuart'"
          [animationDelay]="0"
        ></round-progress>
      </div>
      <br />
      @if (!uploadingComplete) {
        <span class="uploading-label">{{ uploadProgress }}%</span>
      }
      @if (uploadingComplete && !fileResponse) {
        <span class="uploading-label">{{ "general.processing_dots" | translate }}</span>
      }
      <div class="m-y-20">{{ "content_packages.background_upload_notice" | translate }}</div>
    </div>
  }
  @if (uploadingComplete) {
    <div class="text-center">
      <fa-icon icon="check-circle" style="color: green; font-size: 35px"></fa-icon>
      <br />
      <br />
      {{ "content_packages.upload_success" | translate }}
    </div>
  }
  @if (!uploadProgress) {
    <div class="row">
      <div class="col-12 m-b-10">
        @if (!uploadingFile && (!data || !data.id || replacingFile || !data.exists)) {
          @if (!uploader || (!uploader.queue.length && !uploadingComplete)) {
            <div ng2FileDrop class="content-bg content-drop-zone m-b-20" [class.hovering]="hasBaseDropZoneOver" (fileOver)="fileOverBase($event)" [uploader]="uploader">
              <div>{{ (hasBaseDropZoneOver ? "profile.edit.dropit" : "profile.edit.drophere") | translate }}</div>
            </div>
          }
        }
        @if (uploadingFile) {
          <div class="content-bg m-b-20 d-flex justify-content-between align-items-center">
            <span class="brandfont-black">{{ uploadingFile.file.name }}</span>
            <button class="btn btn-sm btn-secondary" (click)="clearFile()">{{ "content_packages.remove" | translate }}</button>
          </div>
        }

        @if (data.id && !uploadingFile && !replacingFile && data.exists) {
          <div class="drop-zone">
            <strong>{{ "content_packages.file_storage_location" | translate }}: {{ data.folder + "/" + data.fileName }}</strong>
            <br />
            <br />
            <button class="btn btn-primary" (click)="replacingFile = true">{{ "content_packages.replace_file" | translate }}</button>
          </div>
        }
      </div>

      <!-- Content Type Selection for Content Packages Manager -->
      @if (isContentPackagesManager && isCreating) {
        <div class="col-12 m-b-20">
          <div class="form-group">
            <label class="control-label">{{ "content_packages.content_type" | translate }}*</label>
            <myp-segmented-bar [options]="segmentedBarOptions" (selected)="onSegmentedBarSelection($event)" [white]="true"></myp-segmented-bar>
            <small class="text-muted d-block m-t-5">
              {{ "content_packages.content_type_help" | translate }}
            </small>
          </div>
        </div>
      }

      @if (sampleOnly) {
        <div class="form-group col-12">
          <label class="control-label" for="title">{{ "content_packages.title" | translate }}*</label>
          <input type="text" name="title" id="title" [(ngModel)]="data.title" class="form-control" />
        </div>
      }
      @if (!productImageOnly && !sampleOnly) {
        <div class="form-group col-12 col-md-6">
          <label class="control-label" for="fileName">{{ "content_packages.filename" | translate }}*</label>
          <input ngbAutofocus type="text" [disabled]="uploadingFile" name="fileName" id="fileName" [(ngModel)]="data.fileName" class="form-control" />
        </div>
        <div class="form-group col-12 col-md-6">
          <label class="control-label" for="contentLength">{{ "content_packages.filesize" | translate }}</label>
          <input type="text" name="contentLength" [disabled]="uploadingFile" [class.disabled]="uploadingFile" id="contentLength" [(ngModel)]="data.contentLength" class="form-control" />
        </div>
        <div class="form-group col-12 col-md-6">
          <label class="control-label" for="folder">{{ "content_packages.folder" | translate }}*</label>
          <input type="text" name="folder" id="folder" [(ngModel)]="data.folder" class="form-control" />
        </div>

        <div class="form-group col-12 col-md-6">
          <label class="control-label" for="release_date">{{ "content_packages.release_date" | translate }}</label>
          <div
            class="form-control pointer"
            tabindex="0"
            (keyup.enter)="showDatePicker()"
            (keydown.space)="showDatePicker(); $event.preventDefault()"
            name="release_date"
            id="release_date"
            (click)="showDatePicker()"
          >
            {{ data.releaseDate ? (data.releaseDate | date) : ("content_packages.none_selected" | translate) }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6">
          <label class="control-label" for="title">{{ "content_packages.title" | translate }}*</label>
          <input type="text" name="title" id="title" [(ngModel)]="data.title" class="form-control" />
        </div>
        @if ((isContentPackagesManager ? selectedContentType : data.type) == "firmware") {
          <div class="form-group col-12 col-md-6">
            <label class="control-label" for="serialCutin">{{ "content_packages.serial_cut_in" | translate }}</label>
            <input ngbAutofocus type="text" name="serialCutin" id="serialCutin" [(ngModel)]="data.serialCutin" class="form-control" />
          </div>
        }
        <div class="form-group col-12 col-md-6">
          <label class="control-label" for="stringId">{{ "content_packages.identifier" | translate }}*</label>
          <input type="text" name="stringId" id="stringId" [(ngModel)]="data.stringId" (blur)="data.stringId = (data.stringId || '').trim().replace(/\s+/g, '_')" class="form-control" />
        </div>
        @if ((isContentPackagesManager ? selectedContentType : data.type) != "firmware") {
          <div class="form-group col-md-6">
            <label class="control-label" for="downloadSection">{{ "content_packages.download_section" | translate }}</label>
            <select class="form-control" name="downloadSection" [(ngModel)]="data.downloadSection">
              <option value="no_download">{{ "download_sections.no_download" | translate }}</option>
              <option value="demos_tutorials">{{ "download_sections.demos_tutorials" | translate }}</option>
              <option value="installers">{{ "download_sections.installers" | translate }}</option>
              <option value="misc">{{ "download_sections.misc" | translate }}</option>
              <option value="owners_manuals">{{ "download_sections.owners_manuals" | translate }}</option>
              <option value="presets">{{ "download_sections.presets" | translate }}</option>
              <option value="release_notes">{{ "download_sections.release_notes" | translate }}</option>
              <option value="soundsets">{{ "download_sections.soundsets" | translate }}</option>
            </select>
          </div>
        }
        <div class="form-group col-12 col-md-6">
          <label class="control-label" for="version">{{ "content_packages.version" | translate }}</label>
          <input type="text" name="version" id="version" [(ngModel)]="data.version" class="form-control" />
        </div>
        @if ((isContentPackagesManager ? selectedContentType : data.type) != "firmware") {
          <div class="form-group col-12 col-md-6">
            <label class="control-label" for="osRequirement">{{ "content_packages.os_requirement" | translate }}</label>
            <input type="text" name="osRequirement" id="osRequirement" [(ngModel)]="data.osRequirement" class="form-control" />
          </div>
        }
        <div class="form-group col-12">
          <label class="control-label" for="description">{{ "general.description" | translate }}</label>
          <textarea name="description" id="description" rows="4" [(ngModel)]="data.description" class="form-control">{{ data.description }}</textarea>
        </div>
        <div class="form-group col-12 col-md-6">
          <label class="control-label" for="beta">{{ "beta.classification" | translate }}</label>
          <select class="form-control" name="beta" id="beta" [(ngModel)]="data.beta">
            <option [ngValue]="null">{{ "beta.not_beta" | translate }}</option>
            <option value="public">{{ "beta.public_beta" | translate }}</option>
            <option value="private">{{ "beta.private_beta" | translate }}</option>
            <option value="internal">{{ "beta.internal_beta" | translate }}</option>
          </select>
        </div>

        <!-- Product Selection Section -->
        @if (showProductSelection) {
          <div class="form-group col-12">
            <label class="control-label">{{ "content_packages.related_products" | translate }}*</label>
            <small class="text-muted d-block">{{ "content_packages.related_products_help" | translate }}</small>

            <!-- Product Search -->
            <div class="m-t-10">
              <input class="form-control" [(ngModel)]="associatedProductsQuery" (ngModelChange)="onProductSearchChange()" [placeholder]="'content_packages.search_products' | translate" />
            </div>

            <!-- Search Results -->
            @if (associatedProductsQuery && associatedProductResults && associatedProductResults.length) {
              <div class="product-results product-results--sticky-actions m-t-10 m-b-20 trans-bg border-radius10 p-10">
                <div class="product-results__scroll">
                  @for (product of associatedProductResults; track product) {
                    <myp-list-item [title]="product.title" [subData]="[product.DTYPE]" [includeChevron]="false" [showImage]="false">
                      <div class="button-content">
                        @if (product.added) {
                          <span class="c-link-blue font-weight-bold t-12">{{ "content_packages.added" | translate }}</span>
                        }
                        @if (!product.added) {
                          <fa-icon
                            icon="plus"
                            placement="left"
                            [ngbTooltip]="'content_packages.add_product' | translate"
                            (click)="addProduct(product)"
                            class="action green circle-icon-btn m-r-10"
                          ></fa-icon>
                        }
                      </div>
                    </myp-list-item>
                  }
                </div>
                <div class="product-results__actions text-center">
                  <button class="btn btn-secondary btn-sm" (click)="associatedProductsQuery = ''; associatedProductResults = []">{{ "general.close" | translate }}</button>
                </div>
              </div>
            }

            <!-- Selected Products -->
            @if (selectedProducts.length > 0) {
              <div class="m-t-10">
                <h6>{{ "content_packages.selected_products" | translate }} ({{ selectedProducts.length }})</h6>
                @for (product of selectedProducts; track product) {
                  <myp-list-item [includeChevron]="false" [imageRound]="false" [imageBorder]="false" [photo]="product.imageUrl" [title]="product.title">
                    <div class="button-content">
                      <fa-icon icon="times" placement="left" (click)="removeProduct(product)" [ngbTooltip]="'content_packages.remove' | translate" class="action circle-icon-btn"></fa-icon>
                    </div>
                  </myp-list-item>
                  <hr />
                }
              </div>
            }
          </div>
        }
      }
    </div>
  }
</div>
@if (!uploadProgress) {
  <div class="modal-footer">
    @if (!uploadingComplete) {
      <button type="button" [disabled]="!canSubmitForm" class="btn btn-primary" (click)="submit()">
        <span>{{ "general.submit" | translate }}</span>
      </button>
    }
    <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
  </div>
}
